import { ConnectionName } from "@arelia-types/connection";
import openNewWindow from "@arelia-utils/helpers/openNewWindow";

export const openAuthWindow = (name: ConnectionName | string) => {
    const redirectUrl = `${process.env.REACT_APP_API_ROOT}/api/externalAuth/${name}/redirect`;
    openNewWindow(redirectUrl, { width: 600, height: 600, top: "center", left: "center" });
}
